module.exports = __webpack_public_path__ + "media/30th_anniversary_sweepstakes/answer-green-03561ad5.svg";